import { popoverController } from "@ionic/vue";
import UserPopover from "@/components/User/UserPopover.vue";
import ChangeProjectPopover from '@/components/User/ChangeProjectPopover.vue'
import AddElementPopover from "@/components/hzba/Base/AddElementPopover.vue";
import SortByPopover from "@/components/hzba/Base/SortByPopover.vue";
import { Monitoring } from "./monitoring";

export const popoverHelper = async (ev: Event, name: any, props: any, callback: any) => {

    let comp: any;

    switch (name) {
        case 'user.profileImage': comp = UserPopover; break;
        case 'user.changeProject':comp = ChangeProjectPopover; break;
        case 'hzba.addElements': comp = AddElementPopover; break;
        case 'sortby': comp = SortByPopover; break;
        default: comp = undefined;
    }

    if (!comp) {
        Monitoring.withScope((scope) => {
            scope.setContext("Popover info", { name, props });
            Monitoring.error("Popover name not found");
        });
        return;
    }

    const popover = await popoverController
        .create({
            component: comp,
            cssClass: 'my-custom-class',
            event: ev,
            componentProps: {
                ...props
            },
            translucent: true
        })
    await popover.present();

    popover.onDidDismiss().then((res) => {
        if (res.data) {
            callback(res.data);
        } else {
            // aborted
        }
    })

    // const { role } = await popover.onDidDismiss();
    // Monitoring.consoleOnly('onDidDismiss resolved with role', role);

  };